/** ChevronDown icon (Lucide Apache-2.0). https://lucide.dev */
import type { CSSProperties } from 'react';
interface Props { size?: number; strokeWidth?: number; style?: CSSProperties; className?: string }
export function ChevronDownIcon({ size = 16, strokeWidth = 2, style, className }: Props): JSX.Element {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" style={style} {...(className ? { className } : {})} aria-hidden>
      <path d="m6 9 6 6 6-6" />
    </svg>
  );
}
